/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface UniversalSequenceHitSchema {
  id: string;
  /** @maxLength 255 */
  name: string;
  job_id: string;
  /** @maxLength 255 */
  job_title: string;
  project_id: string;
}
